/** Phân quyền — bảng giá */
export const BANG_GIA_PERMISSION_CODES = {
  WEB_BH_BANG_GIA_LIST: 'WEB_BH_BANG_GIA_LIST',
  WEB_BH_BANG_GIA_DETAIL: 'WEB_BH_BANG_GIA_DETAIL',
  WEB_BH_BANG_GIA_ADD: 'WEB_BH_BANG_GIA_ADD',
  WEB_BH_BANG_GIA_EDIT: 'WEB_BH_BANG_GIA_EDIT',
  WEB_BH_BANG_GIA_DELETE: 'WEB_BH_BANG_GIA_DELETE',
  WEB_BH_BANG_GIA_STATUS: 'WEB_BH_BANG_GIA_STATUS',
  WEB_BH_BANG_GIA_IMPORT: 'WEB_BH_BANG_GIA_IMPORT',
  WEB_BH_BANG_GIA_EXPORT: 'WEB_BH_BANG_GIA_EXPORT',
  WEB_BH_BANG_GIA_FORMULA: 'WEB_BH_BANG_GIA_FORMULA',
  WEB_BH_BANG_GIA_UPDATE_PRICE: 'WEB_BH_BANG_GIA_UPDATE_PRICE',
} as const

export type BangGiaPermissionCode = (typeof BANG_GIA_PERMISSION_CODES)[keyof typeof BANG_GIA_PERMISSION_CODES]

export const BANG_GIA_MUTATE_PERMISSIONS = [
  BANG_GIA_PERMISSION_CODES.WEB_BH_BANG_GIA_ADD,
  BANG_GIA_PERMISSION_CODES.WEB_BH_BANG_GIA_EDIT,
  BANG_GIA_PERMISSION_CODES.WEB_BH_BANG_GIA_DELETE,
  BANG_GIA_PERMISSION_CODES.WEB_BH_BANG_GIA_STATUS,
  BANG_GIA_PERMISSION_CODES.WEB_BH_BANG_GIA_IMPORT,
  BANG_GIA_PERMISSION_CODES.WEB_BH_BANG_GIA_EXPORT,
  BANG_GIA_PERMISSION_CODES.WEB_BH_BANG_GIA_FORMULA,
  BANG_GIA_PERMISSION_CODES.WEB_BH_BANG_GIA_UPDATE_PRICE,
] as const
